module.exports = __webpack_public_path__ + "static/media/logo-conlicitaseg-simbolo.38923735.svg";